/**
 * Free-Shipping-Fortschrittsbalken
 * ---------------------------------
 * Aktualisiert den in free-shipping-bar.liquid gerenderten Balken jedes Mal,
 * wenn sich der Warenkorb ändert (Artikel hinzufügen/entfernen/Menge ändern)
 * oder der Cart-Drawer geöffnet wird.
 *
 * Funktioniert unabhängig vom Theme, indem sowohl fetch()- als auch
 * XMLHttpRequest-Aufrufe an die Shopify-Cart-AJAX-Endpunkte
 * (/cart/add.js, /cart/change.js, /cart/update.js) abgefangen werden
 * (deckt sowohl moderne fetch-Themes als auch jQuery/$.ajax-Themes ab).
 * Zusätzlich wird das <cart-drawer>-Element beobachtet, damit ein Öffnen
 * des Drawers ebenfalls ein Update auslöst, unabhängig davon, wodurch es
 * geöffnet wurde.
 *
 * Sprache: Der Schwellenwert (Land/Markt) kommt weiterhin serverseitig aus
 * free-shipping-bar.liquid (150 € DE/AT, 250 € FR). Die ANZEIGESPRACHE des
 * Textes wird unabhängig davon client-seitig über document.documentElement.lang
 * bestimmt (Weglot setzt dieses Attribut beim Sprachwechsel korrekt) - so
 * bekommt z.B. ein Besucher aus Deutschland mit englischsprachigem Browser/
 * Weglot-Auswahl den englischen Text, obwohl die 150-€-Schwelle (DE) gilt.
 * Unterstützt: de (Standard/Fallback), fr, en.
 *
 * Voraussetzung: Auf der Seite steht ein Element aus
 * free-shipping-bar.liquid mit [data-free-shipping-bar].
 * Die im Shop angezeigten Preise sind netto — cart.total_price entspricht
 * daher direkt dem Betrag, der mit der Schwelle verglichen wird.
 */
(function () {
  var CART_ENDPOINT_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var TRANSLATIONS = {
    de: {
      remaining: function (amount) {
        return 'Noch <strong>' + amount + '</strong> bis zum kostenlosen Versand';
      },
      complete: 'Sie haben sich kostenlosen Versand gesichert!'
    },
    fr: {
      remaining: function (amount) {
        return 'Plus que <strong>' + amount + '</strong> pour la livraison gratuite';
      },
      complete: 'Vous avez obtenu la livraison gratuite !'
    },
    en: {
      remaining: function (amount) {
        return '<strong>' + amount + '</strong> away from free shipping';
      },
      complete: 'You’ve unlocked free shipping!'
    }
  };

  function getLang() {
    var raw = (document.documentElement.lang || 'de').toLowerCase();
    if (raw.indexOf('fr') === 0) return 'fr';
    if (raw.indexOf('en') === 0) return 'en';
    return 'de';
  }

  function getBars() {
    return document.querySelectorAll('[data-free-shipping-bar]');
  }

  function formatMoney(cents, lang) {
    var amount = Math.max(cents, 0) / 100;
    if (lang === 'en') {
      return '€' + amount.toFixed(2);
    }
    // de/fr: Komma als Dezimaltrennzeichen, Euro-Zeichen nach dem Betrag
    return amount.toFixed(2).replace('.', ',') + ' €';
  }

  function render(cart) {
    var bars = getBars();
    if (!bars.length) return;

    var lang = getLang();
    var t = TRANSLATIONS[lang] || TRANSLATIONS.de;

    bars.forEach(function (bar) {
      var thresholdCents = parseInt(bar.dataset.thresholdCents, 10);
      if (!thresholdCents) return;

      var total = cart.total_price; // in Cent, netto
      var remaining = thresholdCents - total;
      var percent = Math.min(100, Math.max(0, (total / thresholdCents) * 100));

      var fill = bar.querySelector('[data-free-shipping-fill]');
      var message = bar.querySelector('[data-free-shipping-message]');
      if (fill) fill.style.width = percent + '%';

      if (remaining <= 0) {
        bar.classList.add('free-shipping-bar--complete');
        if (message) message.innerHTML = t.complete;
        var pb = bar.querySelector('[role="progressbar"]');
        if (pb) pb.setAttribute('aria-valuenow', '100');
      } else {
        bar.classList.remove('free-shipping-bar--complete');
        if (message) {
          message.innerHTML = t.remaining(formatMoney(remaining, lang));
        }
        var pb2 = bar.querySelector('[role="progressbar"]');
        if (pb2) pb2.setAttribute('aria-valuenow', String(Math.round(percent)));
      }
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(render)
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('shopify:section:load', refresh);

  // --- fetch() abfangen (moderne Themes) ---
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var result = originalFetch.apply(this, args);
    if (CART_ENDPOINT_RE.test(url)) {
      result.then(refresh).catch(function () {});
    }
    return result;
  };

  // --- XMLHttpRequest abfangen (jQuery/$.ajax-basierte Themes) ---
  var OriginalXHR = window.XMLHttpRequest;
  function PatchedXHR() {
    var xhr = new OriginalXHR();
    var originalOpen = xhr.open;
    xhr.open = function (method, url) {
      this._fsbUrl = url;
      return originalOpen.apply(this, arguments);
    };
    xhr.addEventListener('loadend', function () {
      if (this._fsbUrl && CART_ENDPOINT_RE.test(this._fsbUrl)) {
        refresh();
      }
    });
    return xhr;
  }
  window.XMLHttpRequest = PatchedXHR;

  // --- Öffnen des Cart-Drawers beobachten (fängt jeden Auslöser ab) ---
  function observeCartDrawer() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (!drawer) return;
    var observer = new MutationObserver(function () {
      refresh();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
  }
  document.addEventListener('DOMContentLoaded', observeCartDrawer);
})();